import {
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
  setCookie,
} from "@repo/shared-utils/common-utils";
import { twfInsert, offerAPI, deleteFromCartApi } from "@repo/connection-manager";
import { getUserDetails } from "../services/demogApi";
import { COMMON_SSO_ACCESS_TOKEN } from "@repo/shared-utils/sso.constants";
import {
  TW_EVENT,
  TW_JOURNEY_NAME,
  TW_PROD_NAME,
  PDP_DETAILS,
} from "../../../api-client/src/constants/util";
import { APP_PROMPTS } from "@repo/shared-utils/pwa.constants";
import { logPageActionToNewRelic } from "@repo/shared-utils/newRelic-log-utils";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import type { SSORedirectHandler } from "../../../../apps/trading-mall-app/app/components/ClickHandler/RedirectionConfig.interface";
import { commonInsertParameters, getOrDefaultValue } from "@repo/shared-utils/insert-params";
import { getApplicationIdAndProdCode, getApplicationId } from "./utils";

export const twfHandler: SSORedirectHandler = async (data) => {
  const { mobileNo } = await getSessionData();
  const twfOffer = await offerAPI("TWL");
  const userData = await getUserDetails(mobileNo);
  const custType = getOrDefaultValue(userData?.data?.custType, "NTB");
  if (twfOffer?.length && custType === "ETB") {
    // display loader and redirecting to Bajaj Mall
    setCookie("redirectedToBajajMall", 3, "true");
    return;
  }
  const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, ["TWL"]);
  let response;
  const resume = applicationID !== undefined;

  const appId = await getApplicationId(["TWL"]);
  if (appId) {
    await deleteFromCartApi({ appId, mobileNo, channel: "3in1" });
  }
  try {
    response = await twfInsert({
      ...commonInsertParameters({
        appDtls: {
          custId: userData?.data?.custId,
        },
      }),
      mobileNo,
      custType,
      journeyName: TW_JOURNEY_NAME,
      prodName: TW_PROD_NAME,
      eventCode: TW_EVENT,
      eventType: TW_EVENT,
      eventName: PDP_DETAILS,
      offerId: "",
      offerName: "",
      loanVariant: "",
      apiVersion: "v3",
      ...data.data?.twfInsert,
    });
  } catch (error) {
    logPageActionToNewRelic("BFL_WHEELES_ERROR", {
      component: "Two Wheeler Insert",
      pageUrl: window.location.href,
      message: (error as Error).message,
      debugInfo: JSON.stringify({
        hasAToken: !!localStorage.getItem(COMMON_SSO_ACCESS_TOKEN),
      }),
    });
    return;
  }

  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  if (isOpenInApp()) {
    const { IN_APP_REDIRECTION, BAJAJ_SUPER_APP } = APP_PROMPTS;

    const inAppRedirectionPrompt = `${IN_APP_REDIRECTION}${BAJAJ_SUPER_APP}dynamicinapplink/TWF/${resume ? "resume" : "new"}/${
      response?.id ?? applicationID ?? response?.description
    }`;

    window.tarsier?.invokePrompt(inAppRedirectionPrompt, true);
    return;
  }
  redirectToWebform(callbackUrl.toString(), {
    applicationID: response?.id ?? applicationID,
    custType,
    prodCode: response?.id ? "" : prodCode,
    product: "TWF",
    resume: false,
    description: response?.description ?? "",
  });
};
